import { useEffect, useState } from 'react';
import { fetchData } from '../services/dataApi';

let _cache = null;
let _promise = null;

function fetchCatalog() {
  if (_promise) return _promise;
  _promise = fetchData('languages.json')
    .then((languages) => Object.fromEntries(languages.map((language) => [language.code, {
      description: language.label,
      features: ['basics', 'alphabet', 'conversation', 'vocabulary', 'grammar', 'stories'],
    }])))
    .then((data) => { _cache = data; return _cache; })
    .catch(() => ({}))
    .finally(() => { _promise = null; });
  return _promise;
}

export function useCatalog() {
  const [catalog, setCatalog] = useState(_cache || null);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    let active = true;
    if (_cache) { setCatalog(_cache); setLoading(false); return; }
    const load = () => fetchCatalog().then((data) => {
      if (!active) return;
      setCatalog(data);
      setLoading(false);
    });
    load();
    window.addEventListener('online', load);
    return () => {
      active = false;
      window.removeEventListener('online', load);
    };
  }, []);

  return { catalog, loading };
}
